var map = {
	"./apple-laurel-da-DK.svg": 47113,
	"./apple-laurel-de-DE.svg": 2291,
	"./apple-laurel-en-GB.svg": 74521,
	"./apple-laurel-en-US.svg": 29470,
	"./apple-laurel-es-ES.svg": 49522,
	"./apple-laurel-es-MX.svg": 67366,
	"./apple-laurel-fr-FR.svg": 50697,
	"./apple-laurel-it-IT.svg": 7091,
	"./apple-laurel-nb-NO.svg": 40628,
	"./apple-laurel-nl-NL.svg": 8689,
	"./apple-laurel-pl-PL.svg": 26530,
	"./apple-laurel-pt-BR.svg": 71165,
	"./apple-laurel-pt-PT.svg": 64501,
	"./apple-laurel-sv-SE.svg": 24728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;